import React from "react";
import emptyDashboard from "../../assets/images/empty-dashboard.png";

import styles from "./EmptyContent.module.scss";

export const EmptyContent = ({ message }) => {
	return (
		<div className={styles.emptyDashboard}>
			<img src={emptyDashboard} alt="Empty Dashboard" className={styles.emptyImage}/>
			<p className={styles.emptyMessage}>{message}</p>
		</div>
	);
};
